var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 176,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 22,
    width: 210,
    height: 176
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-120 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "#00693D",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "#00693D",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "#00693D",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "#00693D",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.388 85.0502C130.371 84.7686 131.439 85.4797 131.772 86.6413L135.105 98.262C135.438 99.4212 134.91 100.592 133.927 100.874 132.941 101.155 131.873 100.444 131.54 99.2828L128.208 87.6621C127.875 86.5028 128.403 85.3318 129.388 85.0502Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.739 76.2057C157.724 75.9241 158.792 76.6351 159.125 77.7967L162.457 89.4174C162.791 90.5766 162.263 91.7476 161.277 92.0292 160.294 92.3108 159.226 91.5998 158.893 90.4382L155.561 78.8175C155.227 77.6582 155.755 76.4873 156.739 76.2057Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.852 58.1387 180.984 22",
    stroke: "#FFFFFF",
    strokeWidth: 2.84956,
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92 65.005 128.37 60.1591 129.635 62.1421 110.591 68.1965 111.92 65.005Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6988 73.3357 133.277 55.6489 128.37 60.1591 75.3843 77.5104 75.6988 73.3357Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.091 73.7557 153.869 83.8534 145.852 81.1782",
    stroke: "#FFFFFF",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.782 91.0366 143.456 87.5189 145.094 90.3795 132.847 94.3125 131.782 91.0366Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0429 90.4616 134.882 74.9291 139.936 77.2757 85.6275 94.5754 86.0429 90.4616Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6038 122.958 24.992 127.87 28.8546 131.871 23.3775 130.904 20.768 135.816 19.9936 130.308 14.5165 129.341 19.5149 126.905 18.7405 121.398 22.6054 125.396 27.6038 122.958Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3027 107.329 18.8789 111.711 21.9883 116.322 16.7622 114.419 13.3385 118.802 13.5309 113.243 8.30485 111.342 13.6506 109.81 13.8453 104.251 16.9547 108.862 22.3027 107.329Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9587 90.7526 14.7605 94.4017 16.9335 99.5198 12.1675 96.6569 7.96928 100.306 9.22005 94.8875 4.45397 92.0222 9.99445 91.5364 11.2452 86.118 13.4182 91.2384 18.9587 90.7526Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5876 74.8141 14.8215 77.6794 16.0723 83.0978 11.8741 79.4487 7.10805 82.314 9.28107 77.1936 5.08288 73.5445 10.6234 74.0303 12.7964 68.9099 14.0471 74.3307 19.5876 74.8141Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6165 58.6385 19.177 59.7954 18.595 65.3265 15.8142 60.5111 10.3746 61.6657 14.0964 57.5332 11.3156 52.7179 16.3962 54.98 20.118 50.8476 19.536 56.3787 24.6165 58.6385Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8228 43.3828 27.2683 43.6738 25.8274 49.0453 23.8351 43.8545 18.2805 44.1455 22.6031 40.6443 20.6108 35.4511 25.2759 38.4806 29.5985 34.9818 28.1577 40.3533 32.8228 43.3828Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.827 14.7066 116.32 13.9322 121.229 11.3227 120.264 5.84555 124.265 9.70816 129.175 7.09867 126.736 12.0971 130.737 15.9597 125.23 15.1853 122.792 20.1837 121.827 14.7066Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.743 10.093 100.221 10.7712 104.291 6.97664 101.939 1.936 106.804 4.63232 110.871 0.840107 109.81 6.3008 114.675 8.99712 109.153 9.67296 108.092 15.1337 105.743 10.093Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1716 6.88747 82.4572 3.94005 88.0047 3.55051 89.3493-1.84448 91.4332 3.31115 96.9807 2.92395 92.7215 6.49792 94.803 11.6559 90.0862 8.70848 85.827 12.2825 87.1716 6.88747Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5367 10.2479 64.0945 6.8992 69.6538 6.99776 71.4654 1.73888 73.0916 7.05643 78.6532 7.15499 74.096 10.3441 75.7222 15.6617 71.28 12.3153 66.7251 15.5044 68.5367 10.2479Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.925 17.4921 45.8844 15.1407 51.3427 14.08 52.0209 8.56064 54.7172 13.4253 60.1779 12.3646 56.3834 16.4314 59.0797 21.296 54.039 18.9446 50.2468 23.0114 50.925 17.4921Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7374 28.8077 30.5794 26.7262 35.9767 25.3792 36.3639 19.8317 39.3114 24.5485 44.7087 23.2038 41.1324 27.463 44.0798 32.1798 38.9242 30.096 35.3478 34.3575 35.7374 28.8077Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0003 143.522 41.543 147.192 35.7163 147.192 43.8381 126.068 49.8362 126.068 57.7937 147.195 51.9364 147.195 50.566 143.524 43.0003 143.522ZM46.8371 132.596 46.7808 132.596 44.5116 139.319 49.0805 139.322 46.8371 132.596Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8361 130.721 64.8361 134.253 71.0266 134.253 71.0266 138.904 64.8361 138.902 64.8361 142.544 71.3645 142.546 71.3645 147.195 59.3449 147.195 59.3449 126.07 71.3621 126.072 71.3621 130.721 64.8361 130.721Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2099 147.199 85.3741 147.197 80.1879 139.073 80.134 139.073 80.134 147.197 74.6428 147.197 74.6404 126.072 82.8491 126.072C87.0238 126.075 90.1918 128.062 90.1918 132.575 90.1918 135.487 88.5655 138.007 85.5689 138.54L92.2099 147.199ZM80.134 135.541 80.6643 135.541C82.4572 135.541 84.4753 135.206 84.4753 132.911 84.4753 130.611 82.4572 130.275 80.6643 130.275L80.1316 130.275 80.134 135.541Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.86 136.245C115.86 143.083 110.957 147.901 104.176 147.899 97.3984 147.899 92.4939 143.081 92.4939 136.245 92.4915 129.855 98.0954 125.373 104.176 125.375 110.256 125.375 115.86 129.86 115.86 136.245ZM98.208 136.273C98.208 139.915 100.897 142.576 104.176 142.576 107.454 142.576 110.143 139.918 110.143 136.273 110.143 133.361 107.454 130.698 104.176 130.698 100.897 130.698 98.208 133.359 98.208 136.273Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64 147.204 121.149 147.202 121.149 130.728 116.608 130.728 116.608 126.077 131.176 126.079 131.179 130.73 126.64 130.728 126.64 147.204Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.552 130.73 138.552 134.26 144.745 134.26 144.745 138.911 138.552 138.911 138.552 142.553 145.08 142.553 145.083 147.204 133.061 147.204 133.058 126.079 145.08 126.079 145.08 130.73 138.552 130.73Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.459 133.171C162.338 131.657 160.517 130.845 158.639 130.845 155.279 130.845 153.007 133.422 153.007 136.698 153.007 140.033 155.307 142.443 158.726 142.443 160.517 142.443 162.31 141.574 163.459 140.202L163.459 146.786C161.638 147.347 160.322 147.767 158.614 147.767 155.673 147.765 152.869 146.646 150.684 144.656 148.359 142.555 147.296 139.807 147.293 136.67 147.293 133.786 148.384 131.012 150.403 128.938 152.475 126.809 155.474 125.521 158.442 125.521 160.209 125.521 161.833 125.913 163.457 126.586L163.459 133.171Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5766 91.0061 79.3854 54.9683",
    stroke: "#FFFFFF",
    strokeWidth: 2.84956,
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.316 58.1387 116.087 43.8733 130.855 49.2917",
    stroke: "#FFFFFF",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.309 82.5956 136.332 89.5629 135.175 77.9962",
    stroke: "#FFFFFF",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.631 75.9076C134.072 76.7876 128.851 72.9931 127.968 67.4338",
    stroke: "#FFFFFF",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.048 55.6582C142.607 54.7782 147.22 58.6901 148.1 64.2494",
    stroke: "#FFFFFF",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2321 163.107C52.1946 163.645 52.2204 164.079 52.5982 164.759 52.8868 165.208 53.3163 165.7 54.0836 165.7 55.3954 165.7 55.6958 164.541 55.8483 164.107L56.9184 164.107C56.8316 164.569 56.7307 165.09 56.3294 165.628 55.8366 166.381 54.98 166.756 54.0977 166.756 53.2294 166.756 52.333 166.367 51.7651 165.541 51.3263 164.889 51.0869 163.788 51.0987 162.673 51.1104 161.559 51.3756 160.442 51.9177 159.747 52.6357 158.82 53.5298 158.529 54.3488 158.604 55.1678 158.677 55.9117 159.111 56.3153 159.691 57.0334 160.805 57.0451 161.702 57.0569 163.107L52.2321 163.107ZM55.9117 162.035C55.9516 161.326 55.5972 160.472 55.433 160.268 55.2945 159.935 54.8158 159.66 54.2854 159.604 53.7715 159.545 53.1895 159.719 52.8375 160.268 52.6733 160.442 52.2955 161.268 52.272 162.035L55.9117 162.035Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9764 164.18C59.0163 164.917 59.3801 165.395 60.1216 165.656 60.375 165.743 60.7153 165.743 61.0556 165.743 61.3841 165.642 61.7126 165.541 61.8863 165.395 62.1139 165.208 62.304 164.844 62.304 164.468 62.304 164.079 62.1139 163.701 61.5836 163.497 60.7529 163.267 59.6945 163.035 59.129 162.732 58.6103 162.514 58.1574 161.993 58.1574 160.878 58.1574 159.428 59.2909 158.604 60.5909 158.604 62.771 158.604 63.0338 160.097 63.0479 160.948L62.013 160.948C62.013 160.559 61.9755 159.733 60.4994 159.733 59.8588 159.733 59.3801 160.139 59.2158 160.545 59.0656 160.934 59.1642 161.369 59.5326 161.587 59.8963 161.819 60.4267 161.965 61.0814 162.152 61.6094 162.253 62.1397 162.399 62.6067 162.732 63.1863 163.121 63.4116 163.875 63.3248 164.614 63.2356 165.353 62.832 166.076 62.1397 166.44 61.7995 166.611 61.37 166.714 60.9289 166.756 60.49 166.756 60.0348 166.756 59.657 166.656 58.1199 166.252 57.9814 164.889 57.9814 164.18L58.9764 164.18Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.818 163.802C69.7946 164.44 69.642 164.989 69.466 165.337 68.9498 166.336 67.9407 166.799 66.9715 166.756 66 166.7 65.0684 166.149 64.653 165.149 64.3878 164.527 64.1743 163.586 64.2001 162.57 64.2236 161.573 64.4747 160.5 65.1458 159.632 65.6738 158.937 66.4177 158.632 67.1358 158.604 67.8515 158.588 68.5461 158.834 68.999 159.285 69.5153 159.66 69.7429 160.5 69.818 161.383L68.7714 161.383C68.6588 160.587 68.5086 160.209 68.0674 159.963 67.8773 159.85 67.5511 159.702 67.1592 159.719 66.758 159.747 66.3027 159.935 65.8615 160.514 65.5729 160.89 65.3969 161.629 65.3453 162.399 65.2936 163.166 65.3711 163.948 65.5846 164.44 65.9883 165.353 66.643 165.642 67.2226 165.611 67.8163 165.569 68.3326 165.194 68.4828 164.788 68.6353 164.468 68.762 164.093 68.7972 163.802L69.818 163.802Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0793 166.423 75.0793 165.611 75.0558 165.611C74.8516 165.975 74.5747 166.294 74.3236 166.44 73.981 166.67 73.4647 166.756 72.9884 166.756 72.5214 166.756 72.0919 166.67 71.9277 166.583 71.4372 166.28 71.0078 165.7 70.8834 164.874L70.8834 158.82 71.9418 158.82 71.9418 164.194C71.9277 164.759 72.1178 165.177 72.4463 165.409 72.6106 165.527 72.81 165.6 73.0377 165.611 73.2653 165.642 73.5164 165.611 73.7815 165.527 74.9267 165.062 75.0793 163.933 75.0793 162.948L75.0793 158.82 76.1376 158.82 76.1376 166.423 75.0793 166.423Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6603 163.107C78.6227 163.645 78.6485 164.079 79.0263 164.759 79.3173 165.208 79.7444 165.7 80.5141 165.7 81.8236 165.7 82.1263 164.541 82.2765 164.107L83.3489 164.107C83.2597 164.569 83.1588 165.09 82.7552 165.628 82.2647 166.381 81.4082 166.756 80.5259 166.756 79.6553 166.756 78.7612 166.367 78.1933 165.541 77.7521 164.889 77.5151 163.788 77.5268 162.673 77.5386 161.559 77.8037 160.442 78.3458 159.747 79.0639 158.82 79.958 158.529 80.777 158.604 81.5959 158.677 82.3398 159.111 82.7435 159.691 83.4615 160.805 83.4733 161.702 83.4874 163.107L78.6603 163.107ZM82.3398 162.035C82.3774 161.326 82.023 160.472 81.8611 160.268 81.7227 159.935 81.2439 159.66 80.7136 159.604 80.1973 159.545 79.6177 159.719 79.2657 160.268 79.1014 160.442 78.7236 161.268 78.6978 162.035L82.3398 162.035Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8367 155.866 85.895 155.866 85.895 166.423 84.8367 166.423 84.8367 155.866Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.759 165.266C92.759 165.482 92.9961 165.715 93.2612 165.715 93.3387 165.715 93.4255 165.715 93.5006 165.67L93.5006 166.627C93.2495 166.714 93.0359 166.756 92.6816 166.756 92.2029 166.756 91.7359 166.163 91.7007 165.656 91.1821 166.104 90.464 166.756 89.5957 166.756 88.1197 166.756 87.2021 165.874 87.289 164.382 87.3664 163.121 87.9953 162.629 88.6758 162.399 89.8726 161.993 90.4898 162.122 91.1187 161.948 91.2595 161.92 91.6491 161.775 91.6491 161.369L91.6491 160.472C91.5622 159.935 90.6423 159.691 89.936 159.691 88.6876 159.691 88.6125 160.747 88.5867 161.094L87.5917 161.094 87.6292 160.428C87.7184 159.993 88.0329 159.313 88.7251 158.937 89.0654 158.747 89.4807 158.604 90.0862 158.604 90.4405 158.604 90.8043 158.618 91.2196 158.733 92.0527 158.951 92.7332 159.444 92.759 160.195L92.759 165.266ZM91.6608 162.701C90.8043 163.093 89.6192 163.063 89.0044 163.382 88.8143 163.483 88.3849 163.847 88.3731 164.412 88.3473 165.353 88.9527 165.7 89.5324 165.715 90.9685 165.759 91.6608 164.468 91.6608 164.222L91.6608 162.701Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.432 155.866 103.432 166.44 102.512 166.44 102.512 165.555C102.31 165.83 101.981 166.207 101.604 166.468 101.353 166.656 100.923 166.756 100.47 166.756 100.017 166.756 99.5268 166.656 99.1467 166.454 98.1658 165.888 97.6471 164.555 97.5462 163.166 97.4336 161.789 97.7363 160.355 98.391 159.587 99.0199 158.834 99.7146 158.588 100.332 158.604 100.949 158.604 101.479 158.848 101.768 159.066 102.071 159.285 102.272 159.545 102.348 159.747L102.373 159.747 102.373 155.866 103.432 155.866ZM100.66 165.611C101.177 165.569 101.681 165.28 101.932 164.788 102.789 163.136 102.223 161.122 101.869 160.573 101.592 160.125 101.076 159.864 100.559 159.85 100.043 159.82 99.5127 160.052 99.1725 160.587 98.6187 161.472 98.4544 163.628 99.2734 164.917 99.6136 165.44 100.144 165.656 100.66 165.611Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.79 163.107C105.753 163.645 105.778 164.079 106.156 164.759 106.447 165.208 106.874 165.7 107.644 165.7 108.953 165.7 109.256 164.541 109.406 164.107L110.479 164.107C110.39 164.569 110.289 165.09 109.885 165.628 109.395 166.381 108.538 166.756 107.656 166.756 106.787 166.756 105.891 166.367 105.323 165.541 104.882 164.889 104.643 163.788 104.657 162.673 104.668 161.559 104.934 160.442 105.476 159.747 106.194 158.82 107.088 158.529 107.907 158.604 108.726 158.677 109.47 159.111 109.873 159.691 110.591 160.805 110.603 161.702 110.617 163.107L105.79 163.107ZM109.47 162.035C109.507 161.326 109.155 160.472 108.991 160.268 108.852 159.935 108.374 159.66 107.846 159.604 107.327 159.545 106.75 159.719 106.396 160.268 106.234 160.442 105.853 161.268 105.828 162.035L109.47 162.035Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.266 169.596 115.266 158.82 116.188 158.82 116.188 159.777 116.212 159.777C116.402 159.458 116.653 159.198 117.094 158.893 117.359 158.705 117.775 158.604 118.23 158.604 118.694 158.604 119.175 158.705 119.553 158.923 120.534 159.486 121.053 160.819 121.151 162.211 121.264 163.572 120.961 165.006 120.307 165.773 119.689 166.527 118.985 166.756 118.368 166.756 117.749 166.756 117.221 166.51 116.93 166.294 116.627 166.076 116.428 165.815 116.35 165.611L116.327 165.611 116.327 169.596 115.266 169.596ZM118.04 159.747C117.523 159.792 117.031 160.08 116.765 160.573 115.911 162.225 116.479 164.236 116.831 164.788 117.12 165.222 117.624 165.496 118.141 165.513 118.657 165.527 119.199 165.309 119.527 164.774 120.081 163.891 120.246 161.732 119.427 160.442 119.098 159.921 118.556 159.702 118.04 159.747Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.437 166.423 122.379 166.423 122.379 158.82 123.437 158.82 123.437 166.423ZM123.437 157.372 122.379 157.372 122.379 155.866 123.437 155.866 123.437 157.372Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.183 155.866 126.241 155.866 126.241 166.423 125.183 166.423 125.183 155.866Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.543 166.756C129.334 166.756 127.558 166.062 127.558 162.673 127.558 159.285 129.334 158.604 130.543 158.604 131.756 158.604 133.53 159.285 133.53 162.673 133.53 166.062 131.756 166.756 130.543 166.756ZM130.543 159.82C129.158 159.82 128.642 161.427 128.642 162.673 128.642 163.919 129.158 165.541 130.543 165.541 131.944 165.541 132.446 163.919 132.446 162.673 132.446 161.427 131.944 159.82 130.543 159.82Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.217 158.82 137.264 158.82 137.264 159.935 136.217 159.935 136.217 165.208C136.217 165.684 136.672 165.715 137.264 165.6L137.264 166.67C136.822 166.756 136.534 166.799 136.116 166.756 135.386 166.67 135.159 165.975 135.159 165.684L135.159 159.935 134.239 159.935 134.239 158.82 135.159 158.82 135.159 156.764 136.217 156.764 136.217 158.82Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.978 166.756C139.77 166.756 137.993 166.062 137.993 162.673 137.993 159.285 139.77 158.604 140.978 158.604 142.189 158.604 143.966 159.285 143.966 162.673 143.966 166.062 142.189 166.756 140.978 166.756ZM140.978 159.82C139.591 159.82 139.075 161.427 139.075 162.673 139.075 163.919 139.591 165.541 140.978 165.541 142.377 165.541 142.881 163.919 142.881 162.673 142.881 161.427 142.377 159.82 140.978 159.82Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.92 164.18C145.958 164.917 146.324 165.395 147.068 165.656 147.319 165.743 147.659 165.743 148 165.743 148.328 165.642 148.654 165.541 148.83 165.395 149.058 165.208 149.246 164.844 149.246 164.468 149.246 164.079 149.058 163.701 148.53 163.497 147.697 163.267 146.639 163.035 146.073 162.732 145.557 162.514 145.101 161.993 145.101 160.878 145.101 159.428 146.237 158.604 147.533 158.604 149.713 158.604 149.978 160.097 149.992 160.948L148.959 160.948C148.959 160.559 148.919 159.733 147.446 159.733 146.803 159.733 146.324 160.139 146.16 160.545 146.01 160.934 146.111 161.369 146.477 161.587 146.84 161.819 147.368 161.965 148.025 162.152 148.553 162.253 149.084 162.399 149.548 162.732 150.13 163.121 150.356 163.875 150.269 164.614 150.18 165.353 149.776 166.076 149.084 166.44 148.743 166.611 148.314 166.714 147.875 166.756 147.434 166.756 146.979 166.756 146.601 166.656 145.064 166.252 144.925 164.889 144.925 164.18L145.92 164.18Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4089 59.8541 203.935 13.5215 206.633 15.4481C175.484 24.64 150.02 32.391 130.24 38.7012 110.941 44.8589 86.3034 53.0722 56.3247 63.3436L57.4089 59.8541Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2316 56.4045 197.765 13.1343 200.483 15.2393 60.2741 59.5537 61.2316 56.4045Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.335 48.5807 144.369 35.1061 144.536 56.3458",
    stroke: "#FFFFFF",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.168 65.9343C135.992 64.822 136.75 63.7777 137.86 63.6017 138.972 63.4257 140.016 64.1837 140.192 65.296 140.371 66.4083 139.61 67.4526 138.5 67.6286 137.388 67.8046 136.344 67.0443 136.168 65.9343Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05 63.8411C131.195 54.086 128.752 45.6122 129.724 38.4196 129.778 38.1897 129.888 38.1615 130.059 38.3328 135.541 45.929 138.254 54.3206 138.202 63.5055L137.05 63.8411Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.739 67.3517C145.594 77.1068 147.946 85.4281 146.793 92.3179 146.739 92.5478 146.629 92.576 146.458 92.4023 140.976 84.8062 138.263 76.5553 138.32 67.6474L138.899 67.523 139.739 67.3517Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.983019,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.618 54.4685 194.745 35.5825 198.042 38.4572 144.111 55.6489 137.618 54.4685Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 55.3907 161.779 49.463 163.64 51.3263 142.518 57.9955 142.637 55.3907Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.932 86.6178 159.935 82.1075 161 85.3835 146.932 89.9008 146.932 86.6178Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.227 70.6839 195.496 55.6489 198.793 58.5235 143.83 76.0343 148.227 70.6839Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "#FF3921",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.275 59.9667C149.605 64.9182 148.377 71.517 143.539 74.7038",
    stroke: "#FFFFFF",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.839 66.826C128.344 72.2257 133.232 76.2197 138.754 75.7457",
    stroke: "#FFFFFF",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.345 56.7987C128.311 59.5748 126.41 65.8451 129.1 70.7989",
    stroke: "#FFFFFF",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.048 55.6582C142.785 55.2663 147.777 59.5068 148.199 65.127",
    stroke: "#FFFFFF",
    strokeWidth: 2.42317,
    fill: "none",
    transform: "matrix(1.00099 0 0 1 120 22)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a34e3c6bde79e1cc27982f8d7a703fc2.svg";
export { ForwardRef as ReactComponent };